import { render, staticRenderFns } from "./MiscQuoteView.vue?vue&type=template&id=445a90ac"
import script from "./MiscQuoteView.vue?vue&type=script&lang=js"
export * from "./MiscQuoteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445a90ac')) {
      api.createRecord('445a90ac', component.options)
    } else {
      api.reload('445a90ac', component.options)
    }
    module.hot.accept("./MiscQuoteView.vue?vue&type=template&id=445a90ac", function () {
      api.rerender('445a90ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/miscquote/MiscQuoteView.vue"
export default component.exports